// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2VsGV","alert":"SettungsInbox_alert__3LLPk"};